/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { injectIntl } from 'react-intl';
import { variants } from '../../utils/motionVariants';
import axios from 'axios';
import { useParams } from 'react-router';
import { getUrl, uploadAsync } from '../../utils/S3Utils';
import { toAbsoluteUrl } from '../../../_metronic/_helpers';
import { CardHeader } from '../../components/CardHeader';
import FloorPlanCropComponentRender from '../../components/FloorPlanCropComponentRender';
import { get, head } from 'lodash';
import { Button } from '../../components/Button';
import moment from 'moment';
import { Loading } from '../../components/Loading';
import { shallowEqual, useSelector } from 'react-redux';

function CropFloorPlan({ intl, history }) {
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const { areaId, facilityId, floorPlanId } = useParams();
  const [floorPlan, setFloorPlan] = useState({});
  const canvasRef = useRef(null);
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function getFloorPlan() {
      setIsLoading(true);
      try {
        const { data } = await axios.get(
          `/areas/${areaId}/facilities/${facilityId}/floor-plans/${floorPlanId}`
        );
        if (data) {
          setFloorPlan(data);
          const signedUrl = await getUrl(data.floorPlanURI);
          setUrl(signedUrl);
        }
      } catch {
        setIsLoading(false);
      }
    }

    getFloorPlan();
  }, []);

  async function onContinue() {
    const canvas = canvasRef.current;
    if (canvas.width && canvas.height) {
      setIsLoading(true);
      try {
        const now = moment().format('MMDDhmmss');
        const filename = `${user.entityId}/${floorPlan.floorPlanURI.replace(
          head(floorPlan.floorPlanURI.split('-')),
          now
        )}`;
        const body = await new Promise(resolve => {
          canvas.toBlob(
            blob => {
              blob.name = filename;
              resolve(blob);
            },
            'image/png',
            1
          );
        });
        await uploadAsync(filename, 'image/png', body);
        await axios.put(
          `/areas/${areaId}/facilities/${facilityId}/floor-plans/${floorPlanId}`,
          {
            ...floorPlan,
            croppedFloorPlanURI: filename,
          }
        );
        history.push(
          `/geo-planner/areas/${areaId}/facilities/${facilityId}/floor-plans/${floorPlanId}`
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      history.push(
        `/geo-planner/areas/${areaId}/facilities/${facilityId}/floor-plans/${floorPlanId}`
      );
    }
  }

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={variants}
      className="card flex-row-fluid h-100"
    >
      <CardHeader
        title={intl.formatMessage(
          { id: 'NAME_VALUE' },
          { name: get(floorPlan, 'name', ' ') }
        )}
        subtitle={intl.formatMessage({
          id: 'AREAS.FACILITIES.FLOORPLANS.NEW.SUBTITLE',
        })}
      />
      <div className="card-body h-100 d-flex flex-column justify-content-between">
        <Loading isLoading={isLoading} />
        <div className="d-flex align-items-center flex-sm-column flex-md-row flex-lg-row h-100">
          <div className="col-sm-12 col-md-12 col-lg-3 px-0 text-center">
            <img
              src={toAbsoluteUrl('/media/svg/senseworks/cut.svg')}
              className="mb-0"
              alt="Crop floor-plan"
            ></img>
            <label className="d-block text-center">
              {intl.formatMessage({ id: 'CROP_AREA' })}
            </label>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-9 px-0 text-center">
            {url && (
              <FloorPlanCropComponentRender
                picture={url}
                setLoading={setIsLoading}
                canvasRef={canvasRef}
              />
            )}
          </div>
        </div>
        <div>
          <Button
            classes="w-75px px-12 py-2 my-1 d-flex justify-content-center align-items-center"
            type="button"
            onClick={onContinue}
            title={intl.formatMessage({ id: 'CONTINUE' })}
          />
        </div>
      </div>
    </motion.div>
  );
}

export default injectIntl(CropFloorPlan);
